export default __webpack_public_path__ + "static/media/placeholder_business02-es-web.47b71790.png";